import { Link, NavLink } from 'react-router-dom';
import { Menu, MoreHorizontal } from 'lucide-react';
import { clsx } from 'clsx';
import { Logo } from '../ui/Logo';
import { useAuthStore } from '../../stores/authStore';
import { initials, mobileTabs } from './nav';

interface Props {
  onOpenMenu: () => void;
}

/** Sticky top bar for < lg screens. */
export function MobileTopBar({ onOpenMenu }: Props) {
  const user = useAuthStore((s) => s.user);
  return (
    <header className="sticky top-0 z-30 flex min-h-14 items-center justify-between border-b border-dark-border bg-dark-bg/90 px-3 pt-[env(safe-area-inset-top)] backdrop-blur lg:hidden">
      <button onClick={onOpenMenu} className="grid h-10 w-10 place-items-center rounded-lg text-dark-muted hover:bg-dark-hover hover:text-dark-text" aria-label="Open menu">
        <Menu size={20} />
      </button>
      <Link to="/dashboard" aria-label="Overview"><Logo size={22} /></Link>
      <Link to="/settings" aria-label="Settings" className="grid h-10 w-10 place-items-center">
        <span className="grid h-7 w-7 place-items-center rounded-full bg-primary text-[11px] font-semibold text-on-primary tabular">{initials(user?.name, user?.email)}</span>
      </Link>
    </header>
  );
}

/** Fixed bottom tab bar for < lg screens. "More" opens the full drawer. */
export function MobileTabBar({ onOpenMenu }: Props) {
  const item = 'flex flex-1 flex-col items-center justify-center gap-1 py-2 text-[10.5px] transition-colors';
  return (
    <nav className="fixed inset-x-0 bottom-0 z-30 border-t border-dark-border bg-dark-bg/95 pb-[env(safe-area-inset-bottom)] backdrop-blur lg:hidden" aria-label="Primary">
      <div className="flex h-14 items-stretch">
        {mobileTabs.map(({ to, icon: Icon, label }) => (
          <NavLink key={to} to={to} className={({ isActive }) => clsx(item, isActive ? 'text-primary' : 'text-dark-muted')}>
            <Icon size={19} strokeWidth={1.75} />
            {label}
          </NavLink>
        ))}
        <button onClick={onOpenMenu} className={clsx(item, 'text-dark-muted')}>
          <MoreHorizontal size={19} strokeWidth={1.75} />
          More
        </button>
      </div>
    </nav>
  );
}
